import { ApiProperty } from "@nestjs/swagger";



export class VehicleCategoryDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    vehicleCategory : string;

    @ApiProperty()
    isActive: boolean;
    
    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;
}